import { get } from 'lodash';
import AppleVppApi from 'client/api/v2/AppleVppApi';
import Vue from 'vue';

export const createVppModule = () => ({
  namespaced: true,
  state: {
    locations: [],
    selectedToken: '',
    totalCount: 0,
  },
  actions: {
    async deleteSToken({ dispatch }, tokenId) {
      await AppleVppApi.deleteSToken(tokenId);

      dispatch('fetchLocations');
    },

    fetchLocations({ commit }) {
      return AppleVppApi.getLocations()
        .then(({ locations, totalCount }) => {
          commit('SET_VPP_LOCATIONS', { locations, totalCount });
          commit('CLEAR_SELECTED_TOKEN');
        });
    },

    async renewToken({ dispatch }, payload) {
      await AppleVppApi.putSToken({ tokenId: payload.tokenId, sToken: payload.sToken });
      dispatch('fetchLocations');
    },

    selectItem({ commit }, tokenId) {
      commit('SELECT_ITEM', tokenId);
    },

    uploadSToken({ commit }, payload) {
      return AppleVppApi.postSToken(payload)
        .then((response) => {
          commit('ADD_TOKEN', response);
        });
    },
  },
  mutations: {
    ADD_TOKEN(state, location) {
      const locations = get(state, 'locations', []);
      locations.push(location);
      Vue.set(state, 'locations', locations);
      Vue.set(state, 'totalCount', state.totalCount + 1);
    },

    CLEAR_SELECTED_TOKEN(state) {
      Vue.set(state, 'selectedToken', '');
    },

    SELECT_ITEM(state, tokenId) {
      Vue.set(state, 'selectedToken', tokenId);
    },

    SET_VPP_LOCATIONS(state, { locations, totalCount }) {
      Vue.set(state, 'locations', locations);
      Vue.set(state, 'totalCount', totalCount);
    },
  },
});

export default createVppModule();
